import { API_TAGS } from '../../constants/api';
import { TRANSLATIONS_INVALIDATED_TAGS } from '../../constants/translations';
import { apiSlice } from '../apiSlice';
import { MESSAGES } from './chapterSourcesMessages';

//TODO: Rename chaptersources to activities
//TODO: Stories renamed to bot content

export const chapterSourcesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchChapterSources: builder.query({
      query: ({ orgId, tenantId, urlParams = {} }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/activities`,
        method: 'GET',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: false
        }
      }),
      keepUnusedDataFor: 120, // Keep data for 120 seconds (2 minutes) after the last unsubscribe
      providesTags: (_result, _error, _args) => {
        return [{ type: API_TAGS.CHAPTER_SOURCES, id: 'LIST' }];
      }
    }),

    fetchChapterSource: builder.query({
      query: ({ orgId, tenantId, chaptersourceId, urlParams = {} }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/activities/${chaptersourceId}`,
        method: 'GET',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: false
        }
      }),
      providesTags: (_result, _error, args) => {
        return [{ type: API_TAGS.CHAPTER_SOURCES, id: args.chaptersourceId }];
      }
    }),

    /**
     * Updates all of the bot's chaptersources
     * @param {String} orgId The current organization ID
     * @param {String} tenantId The current bot ID
     * @param {Array} replacementTenantId The bot ID of the bot we are copying from
     * @returns True or false for success or failure
    */
    replaceBotContent: builder.mutation({
      query: ({ orgId, tenantId, replacementTenantId, successMessage = { showMessage: false } }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/content-replacement?replacementTenantId=${replacementTenantId}`,
        method: 'POST',
        body: null,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.UPDATE_CONTENT.ERROR
        },
        successMessage: {
          ...successMessage,
          messages: MESSAGES.UPDATE_CONTENT.SUCCESS
        }
      }),
      transformResponse: () => true,
      invalidatesTags: (_result, error, args) => {
        if (error) {
          return;
        }
        // As we are replacing the entire bot's content, we need to invalidate all of the bot's content
        return [
          { type: API_TAGS.BOTS, id: args.tenantId },
          { type: API_TAGS.CHAPTER_SOURCES, id: 'LIST' },
          { type: API_TAGS.AUTOMATED_ANSWERS, id: 'LIST' },
          { type: API_TAGS.ACTIVITIES, id: 'LIST' },
          { type: API_TAGS.LIVE_CHAT_SYSTEM_MESSAGES, id: 'LIST' }
        ];
      }
    }),

    /**
     * Fetches the default/main chaptersource for the bot
     * @param {String} orgId The current organization ID
     * @param {String} tenantId The current bot ID
     * @returns The main chaptersource object
    */
    fetchMainChapterSource: builder.query({
      query: ({ orgId, tenantId, urlParams = {} }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/activities/main`,
        method: 'GET',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: false
        }
      }),
      providesTags: (_result, _error, args) => {
        return [{ type: API_TAGS.CHAPTER_SOURCES, id: 'main' }];
      }
    }),

    updateMainChapterSource: builder.mutation({
      query: ({ orgId, tenantId, data }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/activities/main`,
        method: 'PATCH',
        body: data,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.UPDATE_MAIN_CHAPTERSOURCE.ERROR
        },
        successMessage: {
          showMessage: true,
          messages: MESSAGES.UPDATE_MAIN_CHAPTERSOURCE.SUCCESS
        }
      }),
      transformResponse: (response) => true,
      invalidatesTags: (result, error, args) => {
        if (error) {
          return;
        }
        return [
          { type: API_TAGS.CHAPTER_SOURCES, id: 'main' }
        ];
      }
    }),

    updateChapterSources: builder.mutation({
      query: ({ orgId, tenantId, data, successMessage = { showMessage: false } }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/activities/batch`,
        method: 'PUT',
        body: data,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.UPDATE_CONTENT.ERROR
        },
        successMessage: {
          ...successMessage,
          messages: MESSAGES.UPDATE_CONTENT.SUCCESS
        }
      }),
      transformResponse: () => true,
      invalidatesTags: (_result, error, args) => {
        let invalidateTags = [
          { type: API_TAGS.ACTIVITIES, id: 'LIST' },
          { type: API_TAGS.BOTS, id: args.tenantId },
          { type: API_TAGS.CHAPTER_SOURCES, id: 'LIST' }
        ];

        if('entityKeys' in args) {
          args.entityKeys.forEach(entityKey => {
            invalidateTags.push({
              type: TRANSLATIONS_INVALIDATED_TAGS[entityKey],
              id: 'LIST'
            });
          });

        }
        if (error) {
          return [];
        }
        return invalidateTags;
      }
    })
  })
});

export const {
  useFetchChapterSourcesQuery,
  useLazyFetchChapterSourcesQuery,
  useFetchChapterSourceQuery,
  useLazyFetchChapterSourceQuery,
  useReplaceBotContentMutation,
  useFetchMainChapterSourceQuery,
  useUpdateMainChapterSourceMutation,
  useUpdateChapterSourcesMutation
} = chapterSourcesSlice;
